import { render, staticRenderFns } from "./UtxoCredentials.vue?vue&type=template&id=deb0d302&scoped=true&"
import script from "./UtxoCredentials.vue?vue&type=script&lang=ts&"
export * from "./UtxoCredentials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb0d302",
  null
  
)

export default component.exports